import type { App, Plugin } from 'vue';
import { type Router } from 'vue-router';
import Toast, { POSITION, useToast } from 'vue-toastification';

export const ToastPlugin = (router: Router): Plugin => ({
  install(app: App) {
    app.use(Toast, {
      // Enable use of router in custom toast component
      // https://github.com/Maronato/vue-toastification/issues/350#issuecomment-1946734530
      onMounted: (_: typeof Toast, toastApp: App) => {
        toastApp.use(router);
      },
      position: POSITION.BOTTOM_CENTER,
      bodyClassName: ['p-toast-body'],
      hideProgressBar: true,
      icon: false,
      transition: 'Vue-Toastification__fade',
      transitionDuration: {
        enter: 500,
        leave: 250,
      },
    });

    app.config.globalProperties.$toast = useToast();
  },
});
